<template>
  <div>
    <div class="wrapper banner-container">
      <div class="col-3 justify-content-center">
        <img
          src="https://cdn.vexels.com/img/seasonal/black-friday-menu.png"
          loading="lazy"
          class="seasonal-image my-3 mx-5"
        />
      </div>
      <div class="col-6 row justify-content-center align-items-center">
        <div class="d-flex seasonal-text">
          <span class="font-weight-bold mr-2"> {{ $t('main.header.seasonal.title') }}</span>
          <span> {{ $t('main.header.seasonal.description') }}&nbsp;</span>
          <span class="font-weight-bold mr-2 counter-seasonal">00:00:00</span>
        </div>
        <UIButton
          class="wrapper mx-4"
          color="green"
          height="30"
          size="14"
          shape="full"
          :extra-data="{ event: '' }"
          :to="$urlBuilder('plans', { keyword: 'top-menu' })"
          @click="
            gaEvent('Click Button Plans Index Menu', $urlBuilder('plans', { keyword: 'top-menu' }))
          "
        >
          {{ $t('main.header.tags.pricing') }}
        </UIButton>
      </div>
      <div class="col-3 pr-0 justify-content-end align-items-center">
        <button class="close" @click="closeMenuSeasonal">
          <Icon icon="close" color="white" />
        </button>
      </div>
    </div>
    <div class="main-options">
      <MenuOptions :hide-menu-seasonal="false" />
    </div>
  </div>
</template>

<script>
import UIButton from 'UI/Button';
import Icon from 'UI/Icon';
import MenuOptions from '../MenuOptions/index';

export default {
  components: {
    UIButton,
    Icon,
    MenuOptions
  },
  methods: {
    gaEvent(action, url) {
      this.$ga.event('Index Menu', action, this.$route.fullPath);
      this.$router.push(url);
    },
    closeMenuSeasonal() {
      this.$cookies.set('vx.hideMenuSeasonal', true);
      this.$emit('closeMenuSeasonal');
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  @include md {
    display: none !important;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  margin-left: 10px;
  margin-right: 10px;
  @include xl {
    margin-left: 2px;
    margin-right: 2px;
  }
}
.seasonal-image {
  max-width: 250px;
  height: auto;

  @include xl {
    max-width: 180px;
  }

  @include lg {
    max-width: 160px;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}
.seasonal-text {
  color: $white;

  @include lg {
    font-size: 12px;
    margin-bottom: 10px;
  }
}
.close {
  outline: none;
  background-color: #ffffff40;
  width: 30px;
  border-radius: 50%;
  justify-content: center;
  height: 30px;
  display: flex;
  text-align: center;
  align-items: center;
  color: white;
  opacity: 1;
  font-weight: 400;
  z-index: 100;
  @include md {
    right: 20px;
    top: 20px;
    background-color: #505050;
  }
}

.close:hover {
  background-color: #27272740;
  @include md {
    background-color: #969696;
  }
}
</style>
